import React from "react";
import { Modal } from "react-bootstrap";

import * as moment from "moment";
import "./ResumoSimulacao.scss";

const ResumoSimulacao = ({ simulacao, onClose, onConfirmar }) => {
  if (!simulacao || !simulacao.simulacoes || simulacao.simulacoes.length === 0) {
    return null;
  }

  const primeiraSimulacao = simulacao.simulacoes[0];
  const semSeguro = primeiraSimulacao.semSeguro;
  const datas = simulacao.datas;

  // Log para debug
  console.log("ResumoSimulacao - simulacao completa:", simulacao);
  console.log("ResumoSimulacao - semSeguro:", semSeguro);
  console.log("ResumoSimulacao - taxas:", semSeguro?.taxas);
  console.log("ResumoSimulacao - despesas:", semSeguro?.despesas);
  console.log("ResumoSimulacao - percentuaisCet:", semSeguro?.percentuaisCet);

  const _num = (v) => v != null ? parseFloat(v) || 0 : 0;

  const dados = {
    valorLiberado: _num(semSeguro?.valoresOperacao?.creditoCliente),
    prazo: primeiraSimulacao?.prazos?.contratacao?.quantidade || 0,
    parcela: _num(semSeguro?.valoresOperacao?.prestacao),
    juroMensal: _num(semSeguro?.taxas?.jurosMensal),
    juroAnual: _num(semSeguro?.taxas?.jurosAnual),
    cetMensal: _num(semSeguro?.taxas?.cetMensal),
    cetAnual: _num(semSeguro?.taxas?.cetAnual),
    primeiroVencimento: datas?.vencimentoPrimeiraPrestacao || null,
    ultimoVencimento: primeiraSimulacao?.vencimentoContrato || null,
    iof: _num(semSeguro?.valoresOperacao?.iofTotal) || _num(semSeguro?.percentuaisCet?.iofTotal),
    totalPagar: _num(semSeguro?.valoresOperacao?.totalPagar),
  };

  console.log("ResumoSimulacao - dados extraídos:", dados);

  const formatarMoeda = (valor) => {
    if (!valor && valor !== 0) return "-";
    return Number(valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2 });
  };

  const formatarData = (data) => {
    if (!data) return "-";
    return moment(data).format("DD/MM/YYYY");
  };

  const formatarPercentual = (valor) => {
    if (!valor && valor !== 0) return "-";
    return `${Number(valor).toFixed(2)}%`;
  };

  return (
    <Modal
      size="lg"
      show={true}
      onHide={onClose}
      centered
      animation={false}
      backdrop="static"
      className="modal-resumo-simulacao"
    >
      <Modal.Body>
        <div className="resumo-simulacao">
          {/* Header */}
          <div className="resumo-header">
            <div className="header-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h3 className="header-title">Simulação de Crédito Trabalhador</h3>
          </div>

          {/* Valor Liberado Destacado */}
          <div className="resumo-destaque">
            <div className="info-card">
              <div className="destaque-label">Valor Liberado</div>
              <div className="destaque-valor">{formatarMoeda(dados.valorLiberado)}</div>
            </div>
          </div>

          {/* Informações do Contrato */}
          <div className="resumo-section">
            <div className="section-title">Informações do Contrato</div>
            <div className="info-grid">
              <div className="info-item">
                <div className="info-label">Prazo</div>
                <div className="info-value">{dados.prazo} meses</div>
              </div>
              <div className="info-item">
                <div className="info-label">Valor da Parcela</div>
                <div className="info-value">{formatarMoeda(dados.parcela)}</div>
              </div>
              <div className="info-item">
                <div className="info-label">Total a Pagar</div>
                <div className="info-value info-value-highlight">{formatarMoeda(dados.totalPagar)}</div>
              </div>
            </div>
          </div>

          {/* Taxas e Encargos */}
          <div className="resumo-section">
            <div className="section-title">Taxas e Encargos</div>
            <div className="info-grid">
              <div className="info-item">
                <div className="info-label">Juros Mensal</div>
                <div className="info-value">{formatarPercentual(dados.juroMensal)}</div>
              </div>
              <div className="info-item">
                <div className="info-label">Juros Anual</div>
                <div className="info-value">{formatarPercentual(dados.juroAnual)}</div>
              </div>
              <div className="info-item">
                <div className="info-label">CET Mensal</div>
                <div className="info-value">{formatarPercentual(dados.cetMensal)}</div>
              </div>
              <div className="info-item">
                <div className="info-label">CET Anual</div>
                <div className="info-value">{formatarPercentual(dados.cetAnual)}</div>
              </div>
              <div className="info-item">
                <div className="info-label">IOF</div>
                <div className="info-value">{formatarMoeda(dados.iof)}</div>
              </div>
            </div>
          </div>

          {/* Datas */}
          <div className="resumo-section">
            <div className="section-title">Vencimentos</div>
            <div className="info-grid">
              <div className="info-item">
                <div className="info-label">Primeiro Vencimento</div>
                <div className="info-value">{formatarData(dados.primeiroVencimento)}</div>
              </div>
              <div className="info-item">
                <div className="info-label">Último Vencimento</div>
                <div className="info-value">{formatarData(dados.ultimoVencimento)}</div>
              </div>
            </div>
          </div>

          {/* Ações */}
          <div className="resumo-actions">
            <button className="btn-action btn-secondary" onClick={onClose}>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19 12H5M5 12L12 19M5 12L12 5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Voltar
            </button>
            {onConfirmar && (
              <button className="btn-action btn-primary" onClick={onConfirmar}>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7088 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.76489 14.1003 1.98232 16.07 2.86"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M22 4L12 14.01L9 11.01"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Confirmar Simulação
              </button>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResumoSimulacao;
